const enviroment = process.env.REACT_APP_ENV

export const isProduction = () => enviroment === 'production'
export const isHomol = () => enviroment === 'test'

export default { isHomol, isProduction }
